define('Search/SearchResultsPagination',["Search/Search", "instantsearch", "jquery"],
   function (Search, instantsearch, $) {
       function SearchResultsPagination(searchResultsPaginationId, pagingPreviousLabel, pagingNextLabel) {

           var w = window.innerWidth;           

           var paginationWidget = instantsearch.widgets.pagination({
			   container: '#' + searchResultsPaginationId,        
			   showFirstLast: false,
			   padding: w < 768 ? 1 : 3,
			   labels: {
				   next: pagingNextLabel,
				   previous: pagingPreviousLabel
			   },
			   cssClasses: { root: "pagination" }
		   });		   
		   
			 var container = $('#' + searchResultsPaginationId);
			 var oldRender = paginationWidget.render;
			 paginationWidget.render = function(params) {
				 var currentState = params.results;
				 	 
				 oldRender.call(this, params);				 
				 
				 if (currentState.nbPages <= 1) 
					 container.hide();
				 else {
					 container.show();					
				 }					 
			 };
			
			 Search.addWidget(paginationWidget);	
       }

       return function InitPagination(args) {
           return args.IsExperienceEditorEditing
               ? null
               : new SearchResultsPagination(                    
                    args.SearchResultsPaginationId,
                    args.PagingPreviousLabel,
                    args.PagingNextLabel);
       };
   });
